// test1771
(1771 && 0);
